import GenericListModule from "../../generic-list-module"
import {GlistColumnConfig} from "../../types/column-config";
import {AggregateFunctionType} from "../../../../data-structures/aggregators/types";
import FieldProto from "../../../../fields3/proto/field-proto";

export const GLIST_DEFAULT_COLUMN_WIDTH: number     = 200
export const GLIST_DEFAULT_COLUMN_MIN_WIDTH: number = 60

export enum GlistColumnType {
    FIELD       = 'field',
    // EMPTY       = 'empty',
    ACTIONS     = 'actions',
    TITLE      = 'title'      // use to set custom header for the glist in the title field ?
}

export enum GlistColumnAlignment {
    LEFT       = 'left',
    CENTER     = 'center',
}

export const GLIST_COLUMN_WIDTH_AUTO = 'auto'

const debug = false
// const debug = "GlistColumn"

export default class GlistColumn {

    private module      : GenericListModule

    public field        : FieldProto //| null // DONT MAKE NULL FOR ACTIONS - CREATE DUMMAY FIELD ACTIONS or just FieldDUMMY
    // public fieldId      : string
    public width        : number | null // why string? string
    public minWidth     : number                // define min width for this column
    public type         : GlistColumnType
    public aggregate    : any
    public alignment    : GlistColumnAlignment
    public renderMethod : string
    public component    : any           // component for actions
    public isAutoWidth  : boolean       // if true - auto width column like title
    public isHidden     : boolean       // if true should not be displayed as column
    public label        : string        = ''    // column header label - by default field.label

    public isTitle      : boolean = false       // true if this is title column

    public aggregateFunction    : AggregateFunctionType | null
    public className    : string | null
    public headerLabelClassName?    : string


    constructor(field:any, columnConfig:GlistColumnConfig, module:GenericListModule) {
        this.module                 = module

        this.field                  = field     // can be empty when actions
        this.width                  = _.get(columnConfig, 'width', this._getDefaultWidth())
        this.minWidth               = _.get(columnConfig, 'minWidth', GLIST_DEFAULT_COLUMN_MIN_WIDTH)
        this.type                   = _.get(columnConfig, 'type', GlistColumnType.FIELD)
        this.aggregate              = _.get(columnConfig, 'aggregate')  //??????
        this.renderMethod           = _.get(columnConfig, 'renderMethod', this.module.defaultRenderMethod)
        this.component              = _.get(columnConfig, 'component')
        this.label                  = _.get(columnConfig, 'label', this.field ? this.field.label : '')
        this.aggregateFunction      = _.get(columnConfig, 'aggregateFunction', null)
        this.className              = _.get(columnConfig, 'className', null)
        this.headerLabelClassName   = _.get(columnConfig, 'headerLabelClassName', undefined)
        this.alignment              = _.get(columnConfig, 'alignment', this.module.config.skin?.defaultAlignment) as GlistColumnAlignment

        // Patch tut pohodu  est' starii usage gde to ?
        if (!_.get(columnConfig, 'alignment') && _.get(columnConfig, 'align')) {
            // @ts-ignore
            this.alignment = _.get(columnConfig, 'align')
        }

        this.isAutoWidth    = this._getIsAutoWidth(columnConfig.width)
        this.isHidden       = false


        this.isTitle   = this.module.config.titleField === this.field?.fieldId

        debug && console.log(debug, "column ", this.fieldId, this)
    }

    _getDefaultWidth():number {
        return this.field && this.field.defaultWidth ? this.field.defaultWidth : GLIST_DEFAULT_COLUMN_WIDTH
    }

    _getIsAutoWidth(width: any = null) {
        return this.module.widthMode === GLIST_COLUMN_WIDTH_AUTO &&
            this.field &&
            this.field.fieldId === this.module.config.titleField &&
            !width
    }

    resetWidth() {
        this.isAutoWidth    = this._getIsAutoWidth()
        this.width          = this.isAutoWidth ? null : this._getDefaultWidth()

        debug && console.log(debug, "resetWidth for", this.fieldId, this.isAutoWidth, this.width)
    }

    setManualWidth(width:number) {
        debug && console.log(debug, "setManualWidth for", this.fieldId, width)

        this.width = width

        // Fix for auto width save to json
        if (this.isAutoWidth) {
            this.isAutoWidth = false
        }
    }

    get fieldId():fieldId|null {
        return this.field ? this.field.fieldId : null
    }

    toJSON() {
        const result:any = {}

        if (this.field)                                                     result['fieldId']           = this.field.fieldId
        if (this.width && !this.isAutoWidth)                                result['width']             = this.width
        if (this.minWidth !== GLIST_DEFAULT_COLUMN_MIN_WIDTH)               result['minWidth']          = this.minWidth
        if (this.type!==GlistColumnType.FIELD)                              result['type']              = this.type
        if (this.alignment !== this.module.config?.skin?.defaultAlignment)  result['alignment']         = this.alignment
        if (this.aggregateFunction)                                         result['aggregateFunction'] = this.aggregateFunction
        // renderMethod -> should not export

        return result
    }
}